(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("fawvm-organization-staff", [], factory);
	else if(typeof exports === 'object')
		exports["fawvm-organization-staff"] = factory();
	else
		root["fawvm-organization-staff"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition